import React from 'react';
import useFeatureFlagAvailabilityUtil from 'shared/util/feature-flag-utils';

interface FeatureFlagProps {
    flagName: string;
    component: React.ReactNode;
}

export const FeatureFlag = ({ flagName, component }: FeatureFlagProps) => {
    const isEnabled = useFeatureFlagAvailabilityUtil(flagName);

    if (!isEnabled) {
        return <></>;
    }

    return <>{component}</>;
};

export default FeatureFlag;
